<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <p>ЧАСТИ</p>
        <span class="miv modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <div class="modal-content__parts" v-if="partsCopy.length">
          <p
            v-for="(p, i) in partsCopy"
            :key="`p-${i}`"
            :class="{ active: i === edit }"
          >
            <input
              v-if="edit === i"
              type="text"
              v-focus
              v-model="p.partName"
              @blur="edit = -1"
              @input="$set(p, 'changed', true)"
            />
            <span v-else>{{ p.partName }}</span>
            <span class="miv" @click="edit = i">c</span>
          </p>
        </div>
        <p class="modal-content-no-results" v-if="!parts.length">
          Няма добавени части в този обект
        </p>
      </div>
      <div class="modal-content">
        <div class="new-part">
          <div class="new-part__input">
            <input
              v-model="newPart"
              type="text"
              placeholder="Добави нова част"
            />
          </div>
          <button @click="addNewPart">+</button>
        </div>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <button class="btn btn-close" @click="close()">
            <span class="miv">F</span>
            Отказ
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="miv">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["parts"],
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      partsCopy: [],
      newPart: "",
      edit: -1,
    };
  },
  methods: {
    addNewPart() {
      if (!this.newPart) {
        return this.$snotify.error("Напишете името на новата част!");
      }
      this.partsCopy.push({ partName: this.newPart });
      this.newPart = "";
    },
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.partsCopy);
    },
  },
  mounted() {
    this.partsCopy = this.$cloneDeep(this.parts);
  },
};
</script>

<style scoped>
input {
  font-family: "Google Sans", Helvetica, Arial, sans-serif;
}
.modal {
  width: 430px;
}
.modal-header {
  background: none;
  color: #000;
  height: 30px;
}
.modal-header p {
  font-weight: 700;
}
.modal-close {
  color: #000;
  padding: 0;
}
.modal-content {
  padding-top: 0;
  overflow: initial;
}
.modal-content:nth-child(2) {
  padding-bottom: 0;
}
.modal-content:nth-child(3) {
  margin-top: 1rem;
}
.modal-content__parts {
  background: #deecf9;
  border-radius: 4px;
  overflow: auto;
  max-height: 50vh;
  padding: 4px;
  width: 100%;
}
.modal-content__parts > p {
  align-items: center;
  border-radius: inherit;
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  line-height: 15px;
  margin: 1px 0;
  padding: 6px 20px 6px 4px;
  position: relative;
}
.modal-content__parts > p input {
  background: transparent;
  border: none;
  color: #fff;
  caret-color: #fff;
  font-size: 1rem;
  height: 15px;
  padding: 0 20px 0 0;
}
.modal-content__parts > p .miv {
  color: #fff;
  cursor: pointer;
  display: none;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.modal-content__parts > p.active,
.modal-content__parts > p:hover {
  background: #005a9e;
  color: #fff;
  transition: all 0.1s ease;
}
.modal-content__parts > p:not(.active):hover .miv {
  display: inline;
}
.new-part {
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
}
.new-part__input {
  height: 35px;
  width: 100%;
  position: relative;
}
.new-part__input::before {
  content: "Z";
  font-family: "miv";
  color: #005a9e;
  font-size: 20px;
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.new-part__input input {
  background: #deecf9;
  border: 0;
  color: #005a9e;
  font-weight: 700;
  border-radius: 4px;
  height: 100%;
  padding: 0 10px 0 40px;
  width: 100%;
}
.new-part__input input::placeholder {
  color: #005a9e;
}
.new-part button {
  background: #005a9e;
  border-radius: 4px;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 28px;
  height: 35px;
  width: 35px;
}
.btns {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}
.btns .btn:first-child {
  margin-left: 0;
}
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
